import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { BORDER_WIDTH } from '@atlaskit/avatar';
import { gridSize } from '@atlaskit/theme/constants';
var gutter = BORDER_WIDTH * 2 + gridSize() / 2;

var Stack = function Stack(_ref) {
  var children = _ref.children,
      testId = _ref.testId;
  return jsx("div", {
    "data-testid": testId,
    css: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      display: flex;\n      line-height: 1;\n      margin-right: ", "px;\n\n      > * {\n        margin-right: -", "px;\n      }\n    "])), gutter, gutter)
  }, children);
};

export default Stack;